import './Notice.css'
import type { ReactNode } from 'react'
import { cn } from '@/utilities/misc'
import type { IconName } from '../graphics/iconsAvailable'
import { Icon } from '../graphics/Icon'

type Props = {
  variant?: 'info' | 'warning' | 'error'
  icon?: IconName
  className?: string
  children: ReactNode
}

export function Notice({
  variant,
  icon,
  className,
  children,
}: Props) {
  return (
    <div className={cn(
      'Notice',
      variant?.replace(/^[a-z]/, m => m.toUpperCase()),
      className,
    )}>
      {icon && <Icon icon={icon} />}
      <span className='Content'>
        {children}
      </span>
    </div>
  )
}